import request from "@/utils/request";

export type ConfigItemOption = {
  label: string;
  value: string;
};

export type ConfigItem = {
  id?: number | string;
  groupId?: number | string;
  itemName: string;
  itemCode: string;
  itemType: string;
  sortOrder?: number;
  isRequired?: number;
  validationRule?: string | null;
  placeholder?: string | null;
  description?: string | null;
  itemValue?: any;
  defaultValue?: any;
  paramConfig?: string | null;
  options?: ConfigItemOption[];
  [key: string]: any;
};

export type ConfigGroup = {
  id?: number | string;
  groupName?: string;
  configName?: string;
  groupCode?: string;
  configKey?: string;
  sortOrder?: number;
  status?: number;
  description?: string | null;
  items?: ConfigItem[];
  dataList?: ConfigItem[];
};

export const fetchConfigList = () =>
  request.get<{
    code: number;
    data?: ConfigGroup[];
    message?: string;
  }>("/config/list");

export type ConfigUpdatePayload = {
  id?: number | string;
  groupCode: string;
  items: Array<{
    itemCode: string;
    itemValue: string;
  }>;
};

export const updateConfig = (payload: ConfigUpdatePayload) =>
  request.post("/config/updateValueByGroup", payload);

export interface CreateConfigItemPayload {
  id?: number | string;
  groupId?: number | string;
  groupCode: string;
  itemName: string;
  itemCode: string;
  itemType: string;
  isRequired?: number;
  placeholder?: string;
  description?: string;
  defaultValue?: string;
  paramConfig?: string | null;
  sortOrder?: number;
  status?: number;
}

export const createConfigItem = (payload: CreateConfigItemPayload) =>
  request.post("/config/item/create", payload);

export const updateConfigItem = (payload: CreateConfigItemPayload) =>
  request.post("/config/item/update", payload);

export const deleteConfigItem = (id: number | string) =>
  request.post(`/config/item/delete/${id}`);

export const deleteConfigGroup = (id: number | string) =>
  request.post(`/config/group/delete/${id}`);

export const updateConfigGroupName = (payload: {
  id: number | string;
  groupName: string;
}) => request.post("/config/group/updateName", payload);

export const createConfigGroup = (payload: {
  groupName: string;
  groupCode: string;
}) => request.post("/config/group/create", payload);

export const fetchConfigItem = (itemCode: string) =>
  request.get<{
    code: number;
    data?: ConfigItem | null;
    message?: string;
  }>("/config/value", {
    params: { itemCode },
  });

export const refreshTelegramWebhook = () =>
  request.post("/config/tg/refreshWebhook");

export const refreshConfigCache = () => request.post("/config/refresh");
